import { render } from "./CompletePhenotypeView.vue?vue&type=template&id=7472e7c8&scoped=true"
import script from "./CompletePhenotypeView.vue?vue&type=script&lang=js"
export * from "./CompletePhenotypeView.vue?vue&type=script&lang=js"

import "./CompletePhenotypeView.vue?vue&type=style&index=0&id=7472e7c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7472e7c8"]])

export default __exports__